import { handleApiError } from "@/app/utils/handleApiError";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchSlugControl } from "./slugControl.service";
import { RejectValueType } from "../redux/redux.types";
import {
  SlugControlRequest,
  SlugControlResponse,
} from "./slugControl.types";

export const checkSlug = createAsyncThunk<
  SlugControlResponse,
  SlugControlRequest,
  RejectValueType
>("slugControl/checkSlug", async (data, { rejectWithValue }) => {
  try {
    return await fetchSlugControl(data);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});